<!--==========================
=            LIST            =
===========================-->

<template>
  <!-- list -->
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">List</div>
      </base-header>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            List Playground
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <v-row align="center" class="pa-10">
              <v-row justify="space-around">
                <v-switch v-model="disabled" class="ma-2" label="Disabled"></v-switch>
                <v-switch v-model="dense" class="ma-2" label="Dense"></v-switch>
                <v-switch v-model="twoLine" class="ma-2" label="Two-line"></v-switch>
                <v-switch v-model="threeLine" class="ma-2" label="Three-line"></v-switch>
                <v-switch v-model="shaped" class="ma-2" label="Shaped"></v-switch>
                <v-switch v-model="flat" class="ma-2" label="Flat"></v-switch>
                <v-switch v-model="subheader" class="ma-2" label="Subheader"></v-switch>
                <v-switch v-model="inactive" class="ma-2" label="Inactive"></v-switch>
                <v-switch v-model="subGroup" class="ma-2" label="Sub-group"></v-switch>
                <v-switch v-model="nav" class="ma-2" label="Nav"></v-switch>
                <v-switch v-model="avatar" class="ma-2" label="Avatar"></v-switch>
                <v-switch v-model="rounded" class="ma-2" label="Rounded"></v-switch>
              </v-row>
              <v-card class="mx-auto" max-width="400" tile>
                <v-list
                  :disabled="disabled"
                  :dense="dense"
                  :two-line="twoLine"
                  :three-line="threeLine"
                  :shaped="shaped"
                  :flat="flat"
                  :subheader="subheader"
                  :inactive="inactive"
                  :sub-group="subGroup"
                  :nav="nav"
                  :avatar="avatar"
                  :rounded="rounded"
                >
                  <v-subheader>REPORTS</v-subheader>
                  <v-list-item-group v-model="item" color="primary">
                    <v-list-item v-for="(item, i) in items" :key="i">
                      <v-list-item-avatar v-if="avatar">
                        <v-img :src="item.avatar"></v-img>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title v-html="item.title"></v-list-item-title>
                        <v-list-item-subtitle v-if="twoLine || threeLine" v-html="item.subtitle"></v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-row>
          </div>
        </base-card>
      </v-col>
      <!-- list -->
      <v-col cols="12" sm="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header">Disabled lists</div>
          <div slot="card-body">
            <v-card class="mx-auto" max-width="300" tile>
              <v-list disabled>
                <v-subheader>REPORTS</v-subheader>
                <v-list-item-group v-model="item2" color="primary">
                  <v-list-item v-for="(item, i) in items2" :key="i">
                    <v-list-item-icon>
                      <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title v-text="item.text"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
          </div>
        </base-card>
      </v-col>
      <!-- list -->
      <v-col cols="12" sm="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header">Shaped lists</div>
          <div slot="card-body">
            <v-card class="mx-auto" max-width="300" tile>
              <v-list shaped>
                <v-subheader>REPORTS</v-subheader>
                <v-list-item-group v-model="item2" color="primary">
                  <v-list-item v-for="(item, i) in items2" :key="i">
                    <v-list-item-icon>
                      <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title v-text="item.text"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
          </div>
        </base-card>
      </v-col>

      <!-- list -->
      <v-col cols="12" sm="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header">Dense</div>
          <div slot="card-body">
            <v-card class="mx-auto" max-width="300" tile>
              <v-list dense>
                <v-subheader>REPORTS</v-subheader>
                <v-list-item-group v-model="item2" color="primary">
                  <v-list-item v-for="(item, i) in items2" :key="i">
                    <v-list-item-icon>
                      <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title v-text="item.text"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
            <div style="height:70px"></div>
          </div>
        </base-card>
      </v-col>
      <!-- list -->
      <v-col cols="12" sm="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header">
            Flat
            <div class="textt">Items don't change when selected in v-list with flat property.</div>
          </div>
          <div slot="card-body">
            <v-card class="mx-auto" max-width="300" tile>
              <v-list flat>
                <v-subheader>REPORTS</v-subheader>
                <v-list-item-group v-model="item2" color="primary">
                  <v-list-item v-for="(item, i) in items2" :key="i">
                    <v-list-item-icon>
                      <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title v-text="item.text"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
          </div>
        </base-card>
      </v-col>
      <!-- list -->
      <v-col cols="12" sm="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header">
            Rounded
            <div class="textt">You can make v-list items rounded.</div>
          </div>
          <div slot="card-body">
            <v-card class="mx-auto" max-width="300" tile>
              <v-list rounded>
                <v-subheader>REPORTS</v-subheader>
                <v-list-item-group v-model="item2" color="primary">
                  <v-list-item v-for="(item, i) in items2" :key="i">
                    <v-list-item-icon>
                      <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title v-text="item.text"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
            <div style="height:50px"></div>
          </div>
        </base-card>
      </v-col>

      <!-- list -->
      <v-col cols="12" sm="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header">Avatar with title and action</div>
          <div slot="card-body">
            <v-card max-width="500" class="mx-auto">
              <v-toolbar color="indigo" dark>
                <v-app-bar-nav-icon></v-app-bar-nav-icon>

                <v-toolbar-title>Inbox</v-toolbar-title>

                <div class="flex-grow-1"></div>

                <v-btn icon>
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>

                <v-btn icon>
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </v-toolbar>
              <v-list>
                <v-list-item v-for="item in items3" :key="item.title">
                  <v-list-item-icon>
                    <v-icon v-if="item.icon" color="pink">mdi-star</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                  </v-list-item-content>

                  <v-list-item-avatar>
                    <v-img :src="item.avatar"></v-img>
                  </v-list-item-avatar>
                </v-list-item>
              </v-list>
            </v-card>
          </div>
        </base-card>
      </v-col>
      <!-- list -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Icon with 2 lines and action</div>
          <div slot="card-body">
            <v-card max-width="600" class="mx-auto">
              <v-toolbar color="light-blue" dark>
                <v-app-bar-nav-icon></v-app-bar-nav-icon>

                <v-toolbar-title>My files</v-toolbar-title>

                <div class="flex-grow-1"></div>

                <v-btn icon>
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>

                <v-btn icon>
                  <v-icon>mdi-view-module</v-icon>
                </v-btn>
              </v-toolbar>

              <v-list two-line subheader>
                <v-subheader inset>Folders</v-subheader>

                <v-list-item v-for="item in items4" :key="item.title">
                  <v-list-item-avatar>
                    <v-icon :class="[item.iconClass]" v-text="item.icon"></v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                    <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-btn icon>
                      <v-icon color="grey lighten-1">mdi-information</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>

                <v-divider inset></v-divider>

                <v-subheader inset>Files</v-subheader>

                <v-list-item v-for="item in items5" :key="item.title">
                  <v-list-item-avatar>
                    <v-icon :class="[item.iconClass]" v-text="item.icon"></v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                    <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-btn icon>
                      <v-icon color="grey lighten-1">mdi-information</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-card>
          </div>
        </base-card>
      </v-col>
      <!-- list -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Avatar with 3 lines</div>
          <div slot="card-body">
            <v-card max-width="450" class="mx-auto">
              <v-toolbar color="cyan" dark>
                <v-app-bar-nav-icon></v-app-bar-nav-icon>

                <v-toolbar-title>Inbox</v-toolbar-title>

                <div class="flex-grow-1"></div>

                <v-btn icon>
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </v-toolbar>

              <v-list three-line>
                <template v-for="(item, index) in items6">
                  <v-subheader v-if="item.header" :key="item.header" v-text="item.header"></v-subheader>

                  <v-divider v-else-if="item.divider" :key="index" :inset="item.inset"></v-divider>

                  <v-list-item v-else :key="item.title">
                    <v-list-item-avatar>
                      <v-img :src="item.avatar"></v-img>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title v-html="item.title"></v-list-item-title>
                      <v-list-item-subtitle v-html="item.subtitle"></v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-list>
            </v-card>
          </div>
        </base-card>
      </v-col>
      <!-- list -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Avatar with title and action</div>
          <div slot="card-body">
            <v-card max-width="500" class="mx-auto">
              <v-toolbar color="deep-purple accent-4" dark>
                <v-app-bar-nav-icon></v-app-bar-nav-icon>

                <v-toolbar-title>New Chat</v-toolbar-title>

                <div class="flex-grow-1"></div>

                <v-btn icon>
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </v-toolbar>

              <v-list subheader>
                <v-subheader>Recent chat</v-subheader>

                <v-list-item v-for="item in items7" :key="item.title">
                  <v-list-item-avatar>
                    <v-img :src="item.avatar"></v-img>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                  </v-list-item-content>

                  <v-list-item-icon>
                    <v-icon :color="item.active ? 'deep-purple accent-4' : 'grey'">chat_bubble</v-icon>
                  </v-list-item-icon>
                </v-list-item>
              </v-list>

              <v-divider></v-divider>

              <v-list subheader>
                <v-subheader>Previous chats</v-subheader>

                <v-list-item v-for="item in items8" :key="item.title">
                  <v-list-item-avatar>
                    <v-img :src="item.avatar"></v-img>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </div>
        </base-card>
      </v-col>
      <!-- list -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Nested lists</div>
          <div slot="card-body">
            <v-card class="mx-auto" width="300">
              <v-list>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon>mdi-home</v-icon>
                  </v-list-item-icon>

                  <v-list-item-title>Home</v-list-item-title>
                </v-list-item>

                <v-list-group prepend-icon="account_circle" value="true">
                  <template v-slot:activator>
                    <v-list-item-title>Users</v-list-item-title>
                  </template>

                  <v-list-group no-action sub-group value="true">
                    <template v-slot:activator>
                      <v-list-item-content>
                        <v-list-item-title>Admin</v-list-item-title>
                      </v-list-item-content>
                    </template>

                    <v-list-item v-for="(admin, i) in admins" :key="i" link>
                      <v-list-item-title v-text="admin[0]"></v-list-item-title>
                      <v-list-item-icon>
                        <v-icon v-text="admin[1]"></v-icon>
                      </v-list-item-icon>
                    </v-list-item>
                  </v-list-group>

                  <v-list-group sub-group no-action>
                    <template v-slot:activator>
                      <v-list-item-content>
                        <v-list-item-title>Actions</v-list-item-title>
                      </v-list-item-content>
                    </template>
                    <v-list-item v-for="(crud, i) in cruds" :key="i">
                      <v-list-item-title v-text="crud[0]"></v-list-item-title>
                      <v-list-item-action>
                        <v-icon v-text="crud[1]"></v-icon>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list-group>
                </v-list-group>
              </v-list>
            </v-card>
          </div>
        </base-card>
      </v-col>
      <!-- list -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Subheadings and dividers</div>
          <div slot="card-body">
            <v-card max-width="475" class="mx-auto">
              <v-toolbar color="teal" dark>
                <v-app-bar-nav-icon></v-app-bar-nav-icon>

                <v-toolbar-title>Settings</v-toolbar-title>
              </v-toolbar>

              <v-list two-line subheader>
                <v-subheader>General</v-subheader>

                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Profile photo</v-list-item-title>
                    <v-list-item-subtitle>Change your Google+ profile photo</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Show your status</v-list-item-title>
                    <v-list-item-subtitle>Your status is visible to everyone</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>

              <v-divider></v-divider>

              <v-list subheader two-line flat>
                <v-subheader>Hangout notifications</v-subheader>

                <v-list-item-group v-model="settings" multiple>
                  <v-list-item>
                    <template v-slot:default="{ active, toggle }">
                      <v-list-item-action>
                        <v-checkbox v-model="active" color="primary" @click="toggle"></v-checkbox>
                      </v-list-item-action>

                      <v-list-item-content>
                        <v-list-item-title>Notifications</v-list-item-title>
                        <v-list-item-subtitle>Allow notifications</v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-list-item>

                  <v-list-item>
                    <template v-slot:default="{ active, toggle }">
                      <v-list-item-action>
                        <v-checkbox v-model="active" color="primary" @click="toggle"></v-checkbox>
                      </v-list-item-action>

                      <v-list-item-content>
                        <v-list-item-title>Sound</v-list-item-title>
                        <v-list-item-subtitle>Hangouts message</v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-list-item>

                  <v-list-item>
                    <template v-slot:default="{ active, toggle }">
                      <v-list-item-action>
                        <v-checkbox v-model="active" color="primary" @click="toggle"></v-checkbox>
                      </v-list-item-action>

                      <v-list-item-content>
                        <v-list-item-title>Video sounds</v-list-item-title>
                        <v-list-item-subtitle>Hangouts video call</v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-list-item>

                  <v-list-item>
                    <template v-slot:default="{ active, toggle }">
                      <v-list-item-action></v-list-item-action>

                      <v-list-item-content>
                        <v-list-item-title>Invites</v-list-item-title>
                        <v-list-item-subtitle>Notify when receiving invites</v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
          </div>
        </base-card>
      </v-col>
      <!-- list -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Card image with toolbar and list
            <div class="textt">A list can be combined with a card.</div>
          </div>
          <div slot="card-body">
            <v-card max-width="375" class="mx-auto">
              <v-img src="https://cdn.vuetifyjs.com/images/lists/ali.png" height="300px" dark>
                <v-row class="fill-height">
                  <v-card-title>
                    <v-btn dark icon>
                      <v-icon>mdi-chevron-left</v-icon>
                    </v-btn>

                    <div class="flex-grow-1"></div>

                    <v-btn dark icon class="mr-4">
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>

                    <v-btn dark icon>
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </v-card-title>

                  <div class="flex-grow-1"></div>

                  <v-card-title class="white--text pl-12 pt-12">
                    <div class="display-1 pl-12 pt-12">Ali Conners</div>
                  </v-card-title>
                </v-row>
              </v-img>

              <v-list two-line>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon color="indigo">mdi-phone</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>(650) 555-1234</v-list-item-title>
                    <v-list-item-subtitle>Mobile</v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-icon>
                    <v-icon>mdi-message-text</v-icon>
                  </v-list-item-icon>
                </v-list-item>

                <v-list-item>
                  <v-list-item-action></v-list-item-action>

                  <v-list-item-content>
                    <v-list-item-title>(323) 555-6789</v-list-item-title>
                    <v-list-item-subtitle>Work</v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-icon>
                    <v-icon>mdi-message-text</v-icon>
                  </v-list-item-icon>
                </v-list-item>

                <v-divider inset></v-divider>

                <v-list-item>
                  <v-list-item-icon>
                    <v-icon color="indigo">mdi-email</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>aliconnors@example.com</v-list-item-title>
                    <v-list-item-subtitle>Personal</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-action></v-list-item-action>

                  <v-list-item-content>
                    <v-list-item-title>ali_connors@example.com</v-list-item-title>
                    <v-list-item-subtitle>Work</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-divider inset></v-divider>

                <v-list-item>
                  <v-list-item-icon>
                    <v-icon color="indigo">mdi-map-marker</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>1400 Main Street</v-list-item-title>
                    <v-list-item-subtitle>Orlando, FL 79938</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </div>
        </base-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
export default {
  components: {
    BaseCard,
    BaseHeader
  },
  data: () => ({
    active: true,
    item: 5,
    items: [
      {
        avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg",
        title: "Brunch this weekend?",
        subtitle:
          "<span class='text--primary'>Ali Connors</span> &mdash; I'll be in your neighborhood doing errands this weekend. Do you want to hang out?"
      },
      {
        avatar: "https://cdn.vuetifyjs.com/images/lists/2.jpg",
        title: 'Summer BBQ <span class="grey--text text--lighten-1">4</span>',
        subtitle:
          "<span class='text--primary'>to Alex, Scott, Jennifer</span> &mdash; Wish I could come, but I'm out of town this weekend."
      },
      {
        avatar: "https://cdn.vuetifyjs.com/images/lists/3.jpg",
        title: "Oui oui",
        subtitle:
          "<span class='text--primary'>Sandra Adams</span> &mdash; Do you have Paris recommendations? Have you ever been?"
      },
      {
        avatar: "https://cdn.vuetifyjs.com/images/lists/4.jpg",
        title: "Birthday gift",
        subtitle:
          "<span class='text--primary'>Trevor Hansen</span> &mdash; Have any ideas about what we should get Heidi for her birthday?"
      },
      {
        avatar: "https://cdn.vuetifyjs.com/images/lists/5.jpg",
        title: "Recipe to try",
        subtitle:
          "<span class='text--primary'>Britta Holt</span> &mdash; We should eat this: Grate, Squash, Corn, and tomatillo Tacos."
      }
    ],
    disabled: false,
    dense: false,
    twoLine: false,
    threeLine: false,
    shaped: false,
    flat: false,
    subheader: false,
    inactive: false,
    subGroup: false,
    nav: false,
    avatar: false,
    rounded: false,
    item2: 1,
    items2: [
      {
        text: "Real-Time",
        icon: "mdi-clock"
      },
      {
        text: "Audience",
        icon: "mdi-account"
      },
      {
        text: "Conversions",
        icon: "mdi-flag"
      }
    ],
    items3: [
      {
        icon: true,
        title: "Jason Oner",
        avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg"
      },
      {
        title: "Travis Howard",
        avatar: "https://cdn.vuetifyjs.com/images/lists/2.jpg"
      },
      {
        title: "Ali Connors",
        avatar: "https://cdn.vuetifyjs.com/images/lists/3.jpg"
      },
      {
        title: "Cindy Baker",
        avatar: "https://cdn.vuetifyjs.com/images/lists/4.jpg"
      }
    ],
    items4: [
      {
        icon: "folder",
        iconClass: "grey lighten-1 white--text",
        title: "Photos",
        subtitle: "Jan 9, 2014"
      },
      {
        icon: "folder",
        iconClass: "grey lighten-1 white--text",
        title: "Recipes",
        subtitle: "Jan 17, 2014"
      },
      {
        icon: "folder",
        iconClass: "grey lighten-1 white--text",
        title: "Work",
        subtitle: "Jan 28, 2014"
      }
    ],
    items5: [
      {
        icon: "assignment",
        iconClass: "blue white--text",
        title: "Vacation itinerary",
        subtitle: "Jan 20, 2014"
      },
      {
        icon: "call_to_action",
        iconClass: "amber white--text",
        title: "Kitchen remodel",
        subtitle: "Jan 10, 2014"
      }
    ],
    items6: [
      {
        header: "Today"
      },
      {
        avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg",
        title: "Brunch this weekend?",
        subtitle:
          "<span class='text--primary'>Ali Connors</span> &mdash; I'll be in your neighborhood doing errands this weekend. Do you want to hang out?"
      },
      {
        divider: true,
        inset: true
      },
      {
        avatar: "https://cdn.vuetifyjs.com/images/lists/2.jpg",
        title: 'Summer BBQ <span class="grey--text text--lighten-1">4</span>',
        subtitle:
          "<span class='text--primary'>to Alex, Scott, Jennifer</span> &mdash; Wish I could come, but I'm out of town this weekend."
      },
      {
        divider: true,
        inset: true
      },
      {
        avatar: "https://cdn.vuetifyjs.com/images/lists/3.jpg",
        title: "Oui oui",
        subtitle:
          "<span class='text--primary'>Sandra Adams</span> &mdash; Do you have Paris recommendations? Have you ever been?"
      },
      {
        divider: true,
        inset: true
      },
      {
        avatar: "https://cdn.vuetifyjs.com/images/lists/4.jpg",
        title: "Birthday gift",
        subtitle:
          "<span class='text--primary'>Trevor Hansen</span> &mdash; Have any ideas about what we should get Heidi for her birthday?"
      },
      {
        divider: true,
        inset: true
      },
      {
        avatar: "https://cdn.vuetifyjs.com/images/lists/5.jpg",
        title: "Recipe to try",
        subtitle:
          "<span class='text--primary'>Britta Holt</span> &mdash; We should eat this: Grate, Squash, Corn, and tomatillo Tacos."
      }
    ],
    items7: [
      {
        active: true,
        title: "Jason Oner",
        avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg"
      },
      {
        active: true,
        title: "Ranee Carlson",
        avatar: "https://cdn.vuetifyjs.com/images/lists/2.jpg"
      },
      {
        title: "Cindy Baker",
        avatar: "https://cdn.vuetifyjs.com/images/lists/3.jpg"
      },
      {
        title: "Ali Connors",
        avatar: "https://cdn.vuetifyjs.com/images/lists/4.jpg"
      }
    ],
    items8: [
      {
        title: "Travis Howard",
        avatar: "https://cdn.vuetifyjs.com/images/lists/5.jpg"
      }
    ],
    admins: [
      ["Management", "people_outline"],
      ["Settings", "settings"]
    ],
    cruds: [
      ["Create", "add"],
      ["Read", "insert_drive_file"],
      ["Update", "update"],
      ["Delete", "delete"]
    ],
    settings: [],
    selected2: [2],
    items9: [
      {
        action: "15 min",
        headline: "Brunch this weekend?",
        title: "Ali Connors",
        subtitle:
          "I'll be in your neighborhood doing errands this weekend. Do you want to hang out?"
      },
      {
        action: "2 hr",
        headline: "Summer BBQ",
        title: "me, Scrott, Jennifer",
        subtitle: "Wish I could come, but I'm out of town this weekend."
      },
      {
        action: "6 hr",
        headline: "Oui oui",
        title: "Sandra Adams",
        subtitle: "Do you have Paris recommendations? Have you ever been?"
      },
      {
        action: "12 hr",
        headline: "Birthday gift",
        title: "Trevor Hansen",
        subtitle:
          "Have any ideas about what we should get Heidi for her birthday?"
      },
      {
        action: "18hr",
        headline: "Recipe to try",
        title: "Britta Holt",
        subtitle:
          "We should eat this: Grate, Squash, Corn, and tomatillo Tacos."
      }
    ],
    items10: [
      {
        action: "local_activity",
        title: "Attractions",
        items: [
          {
            title: "List Item"
          }
        ]
      },
      {
        action: "restaurant",
        title: "Dining",
        active: true,
        items: [
          {
            title: "Breakfast & brunch"
          },
          {
            title: "New American"
          },
          {
            title: "Sushi"
          }
        ]
      },
      {
        action: "school",
        title: "Education",
        items: [
          {
            title: "List Item"
          }
        ]
      },
      {
        action: "directions_run",
        title: "Family",
        items: [
          {
            title: "List Item"
          }
        ]
      },
      {
        action: "healing",
        title: "Health",
        items: [
          {
            title: "List Item"
          }
        ]
      },
      {
        action: "content_cut",
        title: "Office",
        items: [
          {
            title: "List Item"
          }
        ]
      },
      {
        action: "local_offer",
        title: "Promotions",
        items: [
          {
            title: "List Item"
          }
        ]
      }
    ]
  }),
  computed: {
    active() {
      let vm = this;
      vm.active.call();
      return active;
    }
  }
};
</script>


<!--====  End of LIST  ====-->
